webpackJsonp([25],{

/***/ 1098:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


function data() {
	return {
		filters: [{
			id: 1, value: 1, label: 'Día', days: 0
		}, {
			id: 2, value: 2, label: 'Semana', days: 7
		}, {
			id: 3, value: 3, label: 'Mes', days: 30
		}, {
			id: 4, value: 4, label: 'Año', days: 365
		}]
	};
}

function applyFilter(filter) {
	this.$emit('apply-filter', filter);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'filters-by-time',
	data: data,
	props: {
		value: {
			type: Number,
			default: 1
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		applyFilter: applyFilter
	}
});

/***/ }),

/***/ 1103:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".filters-by-time[data-v-79facaf4]{color:#85939e;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;width:408px}.filters-by-time button.btn[data-v-79facaf4]{background-color:#fff!important;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.18);box-shadow:0 2px 4px 0 rgba(0,0,0,.18);color:#85939e;font-size:14px!important;height:40px;margin-left:14px;max-width:73px}.filters-by-time button.btn.active[data-v-79facaf4]{background-color:#29abe2!important;color:#fff}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/FiltersByTime.vue"],"names":[],"mappings":"AACA,kCACE,cAAe,AACf,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,WAAuB,CACxB,AACD,6CACI,gCAAmC,AACnC,+CAAoD,AAC5C,uCAA4C,AACpD,cAAe,AACf,yBAA2B,AAC3B,YAAa,AACb,iBAAkB,AAClB,cAAgB,CACnB,AACD,oDACM,mCAAqC,AACrC,UAAa,CAClB","file":"FiltersByTime.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.filters-by-time[data-v-79facaf4] {\n  color: #85939e;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: calc(102px * 4);\n}\n.filters-by-time button.btn[data-v-79facaf4] {\n    background-color: white !important;\n    -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);\n            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);\n    color: #85939e;\n    font-size: 14px !important;\n    height: 40px;\n    margin-left: 14px;\n    max-width: 73px;\n}\n.filters-by-time button.btn.active[data-v-79facaf4] {\n      background-color: #29abe2 !important;\n      color: white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1104:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1103);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("6dcc94fc", content, true);

/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1104)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1098),
  /* template */
  __webpack_require__(1106),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79facaf4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1106:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "filters-by-time"
  }, _vm._l((_vm.filters), function(filter) {
    return _c('v-btn', {
      key: filter.id,
      class: {
        'active': filter.id === _vm.value
      },
      attrs: {
        "disabled": _vm.loading
      },
      on: {
        "click": function($event) {
          _vm.applyFilter(filter)
        }
      }
    }, [_vm._v("\n\t\t" + _vm._s(filter.label) + "\n\t")])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 1300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_FiltersByTime__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_FiltersByTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_FiltersByTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_helper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__clerkinn_reports_sub_component_report_table__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__clerkinn_reports_sub_component_report_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__clerkinn_reports_sub_component_report_table__);



var printRow = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
		var code = _ref2.code;
		var baseUrl, typeDocumentCode, name, responseType, cardModel, response, blob;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						baseUrl = '//pms.controlinn.com/api';
						typeDocumentCode = 'registerCard';
						name = 'TARJETA-DE-EMBARQUE' + code;
						responseType = 'blob';
						cardModel = { details: [{}] };
						_context.next = 7;
						return this.$http.post(baseUrl + '/booking/' + code + '/report/' + typeDocumentCode, cardModel, { responseType: responseType });

					case 7:
						response = _context.sent;
						blob = helperMethods.generateBlob(response.bodyBlob);

						helperMethods.showDownloadDialog(blob, name, 'pdf');

					case 10:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function printRow(_x) {
		return _ref.apply(this, arguments);
	};
}();

var loadResources = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var _ref4, subsidiaries;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/hotel');

					case 2:
						_ref4 = _context2.sent;
						subsidiaries = _ref4.data;

						this.subsidiaries = subsidiaries.data;
						this.subsidiary = this.subsidiaries[0].id;

					case 6:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadResources() {
		return _ref3.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var params, results;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						params = {
							dateStart: this.dateStart,
							dateEnd: helperMethods.formatDate(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["addDays"])(this.date, 1), 'YYYY-MM-DD'),
							idSubsidiary: this.subsidiary
						};
						results = void 0;

						if (!this.subsidiary) {
							_context3.next = 7;
							break;
						}

						_context3.next = 5;
						return this.$http.get('//pms.controlinn.com/api' + '/booking-report/' + this.url + '?', { params: params });

					case 5:
						results = _context3.sent;


						this.rows = results.data.data.map(function (element) {
							var newData = {};
							newData.id = element.id;
							newData.channel = element.channel;
							newData.name = element.customer.data.name;
							newData.lastname = element.customer.data.lastname;
							newData.bookingCode = element.code;
							newData.numReservation = element.numReservation;
							newData.country = element.country;
							newData.isSelected = false;
							newData.roomType = element.bookingRooms.data.roomTypes.data.name;
							newData.codeRoom = element.bookingRooms.data.codeRoom;
							newData.stateName = element.status.name;
							newData.dateStart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(element.bookingStart, 'YYYY-MM-DD');
							newData.dateStartHours = element.bookingStart.split(' ')[1];
							newData.dateEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(element.bookingEnd, 'YYYY-MM-DD');
							newData.dateEndHours = element.bookingEnd.split(' ')[1];
							newData.total = '$ ' + element.total;
							newData.color = element.status.colors;
							newData.employee = element.employee.data.name + ' ' + element.employee.data.lastname;
							newData.paymentStatus = element.paymentStatus.name;
							newData.colorsPayment = element.paymentStatus.colors;
							newData.code = element.code;
							return newData;
						});

					case 7:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadData() {
		return _ref5.apply(this, arguments);
	};
}();

var printReports = function () {
	var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(code) {
		var baseUrl, name, responseType, cardModel, dateStart, dateEnd, idSubsidiary, response, blob;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						baseUrl = '//pms.controlinn.com/api';
						name = 'TARJETA-DE-Reporte' + code;
						responseType = 'blob';
						cardModel = { details: [{}] };
						dateStart = 'dateStart=' + this.dateStart;
						dateEnd = 'dateEnd=' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["addDays"])(this.dateStart, 1), 'YYYY-MM-DD');
						idSubsidiary = 'idSubsidiary=' + this.subsidiary;
						_context4.next = 9;
						return this.$http.post(baseUrl + '/report/' + code + '?' + dateStart + '&' + dateEnd + '&' + idSubsidiary, cardModel, { responseType: responseType });

					case 9:
						response = _context4.sent;
						blob = helperMethods.generateBlob(response.bodyBlob);

						helperMethods.showDownloadDialog(blob, name, 'pdf');

					case 12:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function printReports(_x2) {
		return _ref7.apply(this, arguments);
	};
}();

var printRegistrationCad = function () {
	var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(item) {
		var baseUrl, typeDocumentCode, name, responseType, cardModel, response, blob;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						baseUrl = '//pms.controlinn.com/api';
						typeDocumentCode = 'registerCard';
						name = 'TARJETA-DE-REGISTRO' + item.bookingCode;
						responseType = 'blob';
						cardModel = { details: [{}] };
						_context5.next = 7;
						return this.$http.post(baseUrl + '/booking/' + item.bookingCode + '/report/' + typeDocumentCode, cardModel, { responseType: responseType });

					case 7:
						response = _context5.sent;
						blob = helperMethods.generateBlob(response.bodyBlob);

						helperMethods.showDownloadDialog(blob, name, 'pdf');

					case 10:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this);
	}));

	return function printRegistrationCad(_x3) {
		return _ref8.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var helperMethods = __WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].methods;

function disabled() {
	this.date = this.dateStart;
	this.value = 0;
	this.loadData();
}

function created() {
	this.active = 'all';
	this.loadResources();
}

function columnSortableEvent() {}

function arrowIconStart() {
	var arrow = this.menuStart ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function searchByColumn(search) {
	this.params.search = search;
	this.loadData();
}

function active(newValue) {
	var options = {
		all: 'all',
		checkin: 'arrivals',
		checkout: 'leave',
		inhouse: 'in-house',
		noshow: 'no-show',
		void: 'cancel'
	};
	this.url = options[newValue];
	this.loadData();
}

function onDateFilter(filter) {
	this.value = filter.id;
	if (this.value === 1) {
		this.dateStart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["addDays"])(new Date(), 0), 'YYYY-MM-DD');
		this.date = this.dateStart;
	} else {
		this.dateStart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["addDays"])(new Date(), 1), 'YYYY-MM-DD');
		this.date = this.dateStart;
	}
	this.loadData();
}

function customButtons(_ref6) {
	var btn = _ref6.btn,
	    row = _ref6.row;

	if (btn && btn.name === 'registration-card') {
		if (this.active === 'checkin') {
			this.printRegistrationCad(row);
		}
	} else {
		var reports = {
			inhouse: 'inHouse',
			checkin: 'arrivals',
			checkout: 'leave',
			all: 'all',
			void: 'cancel',
			noshow: 'no-show'
		};
		this.printReports(reports[this.active]);
	}
}

function getStartDate() {
	if (this.value === 1) {
		return helperMethods.formatDate(new Date(), 'YYYY-MM-DD');
	}
	return helperMethods.formatDate(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["addDays"])(new Date(), 0), 'YYYY-MM-DD');
}

function customColor(_ref9) {
	var color = _ref9.color;

	return 'color: ' + color;
}

function actionsButtons() {
	var action = {
		all: this.optionButtonsCheckin,
		checkin: this.optionButtonsCheckin
	};
	return action[this.active] || [];
}

function data() {
	return {
		menuStart: false,
		dateStart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["subDays"])(new Date(), 0), 'YYYY-MM-DD'),
		active: '',
		columns: [{ id: 1, name: '# Rva', code: 'numReservation', isSortable: { down: false, up: false } }, { id: 2, name: 'Nombre', code: 'name', isSortable: { down: false, up: false } }, { id: 3, name: 'Canal de Rva', code: 'channel', isSortable: { down: false, up: false } }, { id: 4, name: 'País', code: 'country', isSortable: { down: false, up: false } }, { id: 5, name: 'Hab.', code: 'roomType', isSortable: { down: false, up: false } }, { id: 6, name: 'Estado', code: 'stateName', isSortable: { down: false, up: false } }, { id: 7, name: 'Fec. Salida', code: 'date', isSortable: { down: false, up: false } }, { id: 8, name: 'Usuario', code: 'employee', isSortable: { down: false, up: false } }, { id: 9, name: 'Importe', code: 'total', isSortable: { down: false, up: false } }],
		columnsNoShow: [{ id: 1, name: '# Rva', code: 'bookingCode', isSortable: { down: false, up: false } }, { id: 2, name: 'Nombre', code: 'name', isSortable: { down: false, up: false } }, { id: 3, name: 'Canal de Rva', code: 'channel', isSortable: { down: false, up: false } }, { id: 4, name: 'País', code: 'country', isSortable: { down: false, up: false } }, { id: 4, name: 'Hab.', code: 'roomType', isSortable: { down: false, up: false } }, { id: 5, name: 'Estado', code: 'stateName', isSortable: { down: false, up: false } }, { id: 6, name: 'Fecha Llegada', code: 'date', isSortable: { down: false, up: false } }, { id: 7, name: 'Usuario', code: 'user', isSortable: { down: false, up: false } }],
		columnsTotal: [{ id: 1, name: '# Rva', code: 'bookingCode', isSortable: { down: false, up: false } }, { id: 2, name: 'Nombre', code: 'name', isSortable: { down: false, up: false } }, { id: 3, name: 'Canal de Rva', code: 'channel', isSortable: { down: false, up: false } }, { id: 4, name: 'País', code: 'country', isSortable: { down: false, up: false } }, { id: 4, name: 'Hab.', code: 'roomType', isSortable: { down: false, up: false } }, { id: 5, name: 'Estado', code: 'stateName', isSortable: { down: false, up: false } }, { id: 6, name: 'Fecha Llegada', code: 'date', isSortable: { down: false, up: false } }, { id: 7, name: 'Usuario', code: 'user', isSortable: { down: false, up: false } }],
		columnsVoid: [{ id: 1, name: '# Rva', code: 'bookingCode', isSortable: { down: true, up: false } }, { id: 2, name: 'Nombre', code: 'name', isSortable: { down: true, up: false } }, { id: 3, name: 'Canal de Rva', code: 'channel', isSortable: { down: true, up: false } }, { id: 4, name: 'País', code: 'country', isSortable: { down: true, up: false } }, { id: 4, name: 'Hab.', code: 'roomType', isSortable: { down: true, up: false } }, { id: 5, name: 'Estado', code: 'stateName', isSortable: { down: true, up: false } }, { id: 6, name: 'Fecha Llegada', code: 'date', isSortable: { down: true, up: false } }, { id: 7, name: 'Usuario', code: 'user', isSortable: { down: true, up: false } }],
		date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
		filters: [{
			id: 1, value: 1, label: 'Hoy'
		}, {
			id: 2, value: 2, label: 'Mañana'
		}],
		items: [{ id: 1, name: 'all', title: 'Total' }, { id: 2, name: 'checkin', title: 'Llegadas' }, { id: 3, name: 'inhouse', title: 'Huéspedes In - House' }, { id: 4, name: 'checkout', title: 'Salidas' }, { id: 5, name: 'void', title: 'Anuladas' }, { id: 6, name: 'noshow', title: 'No Show' }],
		loading: false,
		noShowData: [],
		optionButtonsCheckin: [{
			id: 1,
			icon: 'print',
			name: 'registration-card'
		}],
		printInHouse: {
			btn: { name: 'registration-card' }
		},
		rows: [],
		rowSelected: {},
		subsidiaries: [],
		subsidiary: 0,
		totalData: [],
		value: 1,
		voidData: [],
		url: 'arrivals'
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'report-bookings',
	components: {
		FiltersByTime: __WEBPACK_IMPORTED_MODULE_4__components_shared_FiltersByTime___default.a,
		ReportTable: __WEBPACK_IMPORTED_MODULE_6__clerkinn_reports_sub_component_report_table___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_2_table_run___default.a
	},
	computed: {
		arrowIconStart: arrowIconStart,
		actionsButtons: actionsButtons
	},
	created: created,
	data: data,
	methods: {
		printRow: printRow,
		disabled: disabled,
		searchByColumn: searchByColumn,
		columnSortableEvent: columnSortableEvent,
		customButtons: customButtons,
		customColor: customColor,
		getStartDate: getStartDate,
		loadResources: loadResources,
		loadData: loadData,
		onDateFilter: onDateFilter,
		printReports: printReports,
		printRegistrationCad: printRegistrationCad
	},
	watch: {
		active: active
	}
});

/***/ }),

/***/ 1307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_lib__ = __webpack_require__(880);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var getDeeper = __WEBPACK_IMPORTED_MODULE_1__shared_lib__["a" /* default */].getDeeper;


function customButtons(_ref) {
	var row = _ref.row;

	this.$emit('actions', row);
}

function customColor(_ref2) {
	var colorsPayment = _ref2.colorsPayment;

	return 'color: ' + colorsPayment;
}

function getChannelName(row) {
	return getDeeper('channel', 'data', 'name')(row);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'report-table',
	components: {
		TableRun: __WEBPACK_IMPORTED_MODULE_0_table_run___default.a
	},
	methods: {
		customButtons: customButtons,
		customColor: customColor,
		getChannelName: getChannelName
	},
	props: {
		columns: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		optionButtonsCheckin: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		rows: {
			default: function _default() {
				return [];
			},
			type: Array
		}
	}
});

/***/ }),

/***/ 1417:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".header-booking-data[data-v-6c26882b]{height:31px;position:absolute;right:20px;text-align:right;top:52px;width:calc(100% - 230px)}.header-booking-data p[data-v-6c26882b]{color:#2e394b;font-family:San Francisco Display;font-size:10px;margin:0;text-transform:uppercase}.header-booking-data span[data-v-6c26882b]{color:#29abe2;font-family:San Francisco Display Medium;font-size:15px}.td-state span.booking-td[data-v-6c26882b]{color:#04bee9}.td-state span.inhouse-td[data-v-6c26882b]{color:#00cb28}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/reports/Bookings.vue"],"names":[],"mappings":"AACA,sCACE,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,iBAAkB,AAClB,SAAU,AACV,wBAA0B,CAC3B,AACD,wCACI,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,SAAY,AACZ,wBAA0B,CAC7B,AACD,2CACI,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACnB,AACD,2CACE,aAAe,CAChB,AACD,2CACE,aAAe,CAChB","file":"Bookings.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.header-booking-data[data-v-6c26882b] {\n  height: 31px;\n  position: absolute;\n  right: 20px;\n  text-align: right;\n  top: 52px;\n  width: calc(100% - 230px);\n}\n.header-booking-data p[data-v-6c26882b] {\n    color: #2e394b;\n    font-family: \"San Francisco Display\";\n    font-size: 10px;\n    margin: 0px;\n    text-transform: uppercase;\n}\n.header-booking-data span[data-v-6c26882b] {\n    color: #29abe2;\n    font-family: \"San Francisco Display Medium\";\n    font-size: 15px;\n}\n.td-state span.booking-td[data-v-6c26882b] {\n  color: #04bee9;\n}\n.td-state span.inhouse-td[data-v-6c26882b] {\n  color: #00cb28;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1502:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1417);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("4608bf32", content, true);

/***/ }),

/***/ 1553:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1307),
  /* template */
  __webpack_require__(1651),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1651:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "include-options": "",
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-search": false,
      "include-export-to-excel": false,
      "selectable": false,
      "option-buttons": _vm.optionButtonsCheckin
    },
    on: {
      "custom-button": _vm.customButtons
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.numReservation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name) + " " + _vm._s(props.row.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getChannelName(props.row)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.country))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.roomType)), _c('br'), _vm._v(_vm._s(props.row.codeRoom))]), _vm._v(" "), _c('td', {
          staticClass: "td-state"
        }, [_c('span', {
          style: (_vm.customColor(props.row))
        }, [_vm._v("\n\t\t\t\t" + _vm._s(props.row.paymentStatus) + "\n\t\t\t")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.dateEnd)), _c('br'), _vm._v(_vm._s(props.row.dateEndHours))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.employee))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.total))])]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),

/***/ 1663:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "xl-2": "",
      "lg2": "",
      "text-xs-right": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.subsidiary),
      callback: function($$v) {
        _vm.subsidiary = $$v
      },
      expression: "subsidiary"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "pl-0": "",
      "lg4": ""
    }
  }, [_c('v-layout', {
    staticClass: "calendar-range",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "border-right",
    attrs: {
      "md12": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuStart),
      callback: function($$v) {
        _vm.menuStart = $$v
      },
      expression: "menuStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "disabled": !_vm.dateStart,
      "prepend-icon": "event",
      "append-icon": _vm.arrowIconStart,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.disabled
    },
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "text-xs-right": ""
    }
  }, [_c('section', {
    staticClass: "filters-by-time"
  }, _vm._l((_vm.filters), function(filter) {
    return _c('v-btn', {
      key: filter.id,
      class: {
        'activeBtn': filter.id === _vm.value
      },
      attrs: {
        "disabled": _vm.loading
      },
      on: {
        "click": function($event) {
          _vm.onDateFilter(filter)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(filter.label) + "\n\t\t\t\t")])
  }))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-success white--text",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.customButtons
    }
  }, [_c('v-icon', [_vm._v("print")]), _vm._v("\n\t\t\t\tImprimir Reporte\n\t\t\t")], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    staticClass: "checkin-tabs",
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent"
  }, [_c('v-tabs-slider', {
    staticClass: "default-skyblue"
  }), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-tabs-item', {
      key: item.id,
      attrs: {
        "href": ("#" + (item.name))
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t")])
  })], 2), _vm._v(" "), _c('v-tabs-items', _vm._l((_vm.items), function(item) {
    return _c('v-tabs-content', {
      key: item.id,
      staticClass: "pt-5",
      attrs: {
        "id": item.name
      }
    }, [_c('report-table', {
      attrs: {
        "columns": _vm.columns,
        "rows": _vm.rows,
        "option-buttons-checkin": _vm.actionsButtons
      },
      on: {
        "actions": _vm.printRow,
        "search-event": _vm.searchByColumn
      }
    })], 1)
  }))], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1502)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1300),
  /* template */
  __webpack_require__(1663),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6c26882b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(873);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(872);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var core = __webpack_require__(18);
var LIBRARY = __webpack_require__(143);
var wksExt = __webpack_require__(870);
var defineProperty = __webpack_require__(57).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(9);


/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(881);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(874), __esModule: true };

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(875), __esModule: true };

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(274);
__webpack_require__(273);
module.exports = __webpack_require__(876);


/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(274);
__webpack_require__(273);
module.exports = __webpack_require__(877);


/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(30);
var get = __webpack_require__(277);
module.exports = __webpack_require__(18).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(148);
var ITERATOR = __webpack_require__(9)('iterator');
var Iterators = __webpack_require__(41);
module.exports = __webpack_require__(18).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(289);
var hiddenKeys = __webpack_require__(150).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 880:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);




/* eslint-disable max-len */
var compose = function compose() {
	for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
		fns[_key] = arguments[_key];
	}

	return function () {
		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			args[_key2] = arguments[_key2];
		}

		return fns.reduceRight(function (res, fn) {
			return [fn.call.apply(fn, [null].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(res)))];
		}, args)[0];
	};
};

var curry = function curry(fn) {
	var arity = fn.length;
	return function $curry() {
		for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
			args[_key3] = arguments[_key3];
		}

		if (args.length < arity) {
			return $curry.bind.apply($curry, [null].concat(args));
		}
		return fn.call.apply(fn, [null].concat(args));
	};
};

function setNewProperty(property, value) {
	return function p(obj) {
		var newObj = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, obj);
		newObj[property] = value;
		return newObj;
	};
}

function updateItemInCollection() {
	for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
		args[_key4] = arguments[_key4];
	}

	var _ref = [].concat(args),
	    item = _ref[0],
	    matchProperty = _ref[1],
	    propertyToUpdate = _ref[2],
	    value = _ref[3];

	var newValue = value === null || value === undefined ? item[propertyToUpdate] : value;
	return function inner(currentItem) {
		var newItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, currentItem);
		if (item[matchProperty] === currentItem[matchProperty]) {
			newItem = setNewProperty(propertyToUpdate, newValue)(newItem);
		}
		return newItem;
	};
}

function getPropertysValue(prop) {
	return function inner(obj) {
		return (obj || {})[prop];
	};
}

function identity(id) {
	return function inner() {
		return id;
	};
}

function minorAnEqualTo(val, prop) {
	return function inner(obj) {
		if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) === 'object') {
			return val >= obj[prop];
		}
		return val >= obj;
	};
}

function removeItemFromArrayByIndex(index, arr) {
	return arr.reduce(function (list, item, ind) {
		var newList = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(list));
		if (index === ind) {
			return newList;
		}
		return newList.concat(item);
	}, []);
}

function removeItemFromArray(prop, propValue) {
	return function inner(arr) {
		var newArr = arr || [];
		return newArr.reduce(function (list, item) {
			var newList = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(list));
			if (propValue === item[prop]) {
				return newList;
			}
			return newList.concat(item);
		}, []);
	};
}

function matchWithProperty(prop, val) {
	return function inner(item) {
		if (item[prop] && item[prop] === val) {
			return item;
		}
		return {};
	};
}

function getItemByIndex(index) {
	return function inner(arr) {
		return arr[index] || null;
	};
}

function listByNoMatch(prop, collection) {
	return function inner(list, item) {
		var newList = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(list));
		var exist = !!collection.find(function (c) {
			if ((typeof c === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(c)) === 'object') {
				return c[prop] === item[prop];
			}
			return c === item[prop];
		});
		if (!exist) {
			return newList.concat(item);
		}
		return newList;
	};
}

/* eslint-disable prefer-const */
function equality() {
	for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
		args[_key5] = arguments[_key5];
	}

	var prop1 = args[0],
	    prop2 = args[1];

	if (!prop2) {
		prop2 = prop1;
	}
	return function inner(item) {
		return item[prop1] === prop2;
	};
}

function createPropertyByOtherOne() {
	for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
		args[_key6] = arguments[_key6];
	}

	var prop1 = args[0],
	    prop2 = args[1];

	return function inner(item) {
		var newItem = null;
		if (item.length) {
			var _item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(item, 1);

			newItem = _item[0];
		} else {
			newItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item);
		}
		newItem[prop1] = getPropertysValue(prop2)(newItem);
		return newItem;
	};
}

function setNewPropertyByFunction(prop, fn) {
	var flag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	return function inner(item, index) {
		if (index === null || index === undefined) {
			if (item.length) {
				var _item2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(item, 2),
				    newItem = _item2[0],
				    newIndex = _item2[1];

				return [setNewProperty(prop, fn(newItem, newIndex))(newItem), newIndex];
			}
			return setNewProperty(prop, fn(item, index))(item);
		}
		if (flag) {
			return [setNewProperty(prop, fn(item, index))(item), index];
		}
		return setNewProperty(prop, fn(item, index))(item);
	};
}

function getDeeper() {
	for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
		args[_key7] = arguments[_key7];
	}

	return function inner(item) {
		var newItem = null;
		if (item.length) {
			var _item3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(item, 1);

			newItem = _item3[0];
		} else {
			newItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item);
		}
		args.forEach(function (el) {
			newItem = (newItem || {})[el];
		});
		return newItem;
	};
}

function getDeepPropertyOf(obj, args) {
	var propVal = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, obj);
	args.forEach(function (el) {
		propVal = propVal[el];
	});
	return function inner() {
		return propVal;
	};
}

function getIndexOf() {
	return function inner(item, index) {
		return index;
	};
}

function validateObject(obj) {
	return obj || {};
}

function reduce(fn, col) {
	var acc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

	return col.reduce(fn, acc);
}

function map(fn, col) {
	return col.map(fn);
}

function find(fn, col) {
	return col.find(fn);
}

function forEach(fn, col) {
	return col.forEach(fn);
}

function matchBetweenArrays(collection1, collection2) {
	var _collection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(collection1, 2),
	    arr1 = _collection[0],
	    prop1 = _collection[1];

	var _collection2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(collection2, 2),
	    arr2 = _collection2[0],
	    prop2 = _collection2[1];

	var list = [];
	if (prop2) {
		arr1.forEach(function (a) {
			var val = prop1 ? a[prop1] : a;
			var match = find(equality(prop2, val), arr2);
			list = list.concat(match);
		});
	}
	return list;
}

function decimals(decimal) {
	return function inner(value) {
		return Math.round(value * Math.pow(10, decimal)) / Math.pow(10, decimal);
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	removeItemFromArray: removeItemFromArray,
	removeItemFromArrayByIndex: removeItemFromArrayByIndex,
	compose: compose,
	curry: curry,
	decimals: decimals,
	equality: equality,
	find: find,
	forEach: forEach,
	getDeeper: getDeeper,
	getDeepPropertyOf: getDeepPropertyOf,
	getIndexOf: getIndexOf,
	getItemByIndex: getItemByIndex,
	getPropertysValue: getPropertysValue,
	identity: identity,
	listByNoMatch: listByNoMatch,
	map: map,
	matchBetweenArrays: matchBetweenArrays,
	matchWithProperty: matchWithProperty,
	minorAnEqualTo: minorAnEqualTo,
	reduce: reduce,
	setNewProperty: setNewProperty,
	setNewPropertyByFunction: setNewPropertyByFunction,
	updateItemInCollection: updateItemInCollection,
	createPropertyByOtherOne: createPropertyByOtherOne,
	validateObject: validateObject
});

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(882), __esModule: true };

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(273);
__webpack_require__(884);
module.exports = __webpack_require__(18).Array.from;


/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(57);
var createDesc = __webpack_require__(142);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(61);
var $export = __webpack_require__(39);
var toObject = __webpack_require__(147);
var call = __webpack_require__(284);
var isArrayIter = __webpack_require__(283);
var toLength = __webpack_require__(149);
var createProperty = __webpack_require__(883);
var getIterFn = __webpack_require__(277);

$export($export.S + $export.F * !__webpack_require__(285)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(908), __esModule: true };

/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(909), __esModule: true };

/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(906);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(905);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(916);
__webpack_require__(291);
__webpack_require__(917);
__webpack_require__(918);
module.exports = __webpack_require__(18).Symbol;


/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(273);
__webpack_require__(274);
module.exports = __webpack_require__(870).f('iterator');


/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(141);
var gOPS = __webpack_require__(280);
var pIE = __webpack_require__(276);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(62);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(141);
var toIObject = __webpack_require__(89);
module.exports = function (object, el) {
  var O = toIObject(object);
  var keys = getKeys(O);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) if (O[key = keys[index++]] === el) return key;
};


/***/ }),

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(144)('meta');
var isObject = __webpack_require__(63);
var has = __webpack_require__(58);
var setDesc = __webpack_require__(57).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(90)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(276);
var createDesc = __webpack_require__(142);
var toIObject = __webpack_require__(89);
var toPrimitive = __webpack_require__(281);
var has = __webpack_require__(58);
var IE8_DOM_DEFINE = __webpack_require__(287);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(40) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(89);
var gOPN = __webpack_require__(878).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 916:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(10);
var has = __webpack_require__(58);
var DESCRIPTORS = __webpack_require__(40);
var $export = __webpack_require__(39);
var redefine = __webpack_require__(290);
var META = __webpack_require__(913).KEY;
var $fails = __webpack_require__(90);
var shared = __webpack_require__(151);
var setToStringTag = __webpack_require__(91);
var uid = __webpack_require__(144);
var wks = __webpack_require__(9);
var wksExt = __webpack_require__(870);
var wksDefine = __webpack_require__(869);
var keyOf = __webpack_require__(912);
var enumKeys = __webpack_require__(910);
var isArray = __webpack_require__(911);
var anObject = __webpack_require__(30);
var toIObject = __webpack_require__(89);
var toPrimitive = __webpack_require__(281);
var createDesc = __webpack_require__(142);
var _create = __webpack_require__(288);
var gOPNExt = __webpack_require__(915);
var $GOPD = __webpack_require__(914);
var $DP = __webpack_require__(57);
var $keys = __webpack_require__(141);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(878).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(276).f = $propertyIsEnumerable;
  __webpack_require__(280).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(143)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key) {
    if (isSymbol(key)) return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(31)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(869)('asyncIterator');


/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(869)('observable');


/***/ })

});


// WEBPACK FOOTER //
// static/js/25.ba0ea74ad08eec3eb189.js